import React from "react";
import { Skeleton } from "~/components/Skeleton/Skeleton";
export const QuickSkeleton = () => <Skeleton shape={"Rounded"} borderRadius={"small"}/>;
